import { FunctionComponent } from 'react';
import { TransactionStatus } from '../../state/payment/payment.types';
import {
  PaymentStatusStarted,
  PaymentStatusApproved,
  PaymentStatusCanceled,
  PaymentStatusDeclined,
  PaymentStatusFailed,
} from './statuses';

export const PAYMENT_STATUS_COMPONENTS: Record<
  TransactionStatus['status'],
  FunctionComponent<TransactionStatus>
> = {
  Started: PaymentStatusStarted,
  Approved: PaymentStatusApproved,
  InProgress: PaymentStatusStarted,
  Pending: PaymentStatusStarted,
  Canceled: PaymentStatusCanceled,
  Declined: PaymentStatusDeclined,
  Failed: PaymentStatusFailed,
};
